// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-dialog {
  padding: 16px;
  border-radius: 16px !important;
  width: 100%;
  box-sizing: border-box;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.dialog-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1c1c1c;
}

.close-btn {
  margin-top: -8px;
  margin-right: -8px;
  color: #666;
}

.dialog-content p {
  color: #1c1c1c;
  font-size: 14px;
  font-weight: 400px;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
}

.go-to-payments-btn {
  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);
  border-radius: 24px;
  color: white !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

::ng-deep .mat-dialog-container {
  border-radius: 24px !important;
  padding: 0 !important;
}

:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/link-sent-success-dialog/link-sent-success-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,glEAAglE","sourcesContent":[".success-dialog {\n  padding: 16px;\n  border-radius: 16px !important;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.dialog-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1c1c1c;\n}\n\n.close-btn {\n  margin-top: -8px;\n  margin-right: -8px;\n  color: #666;\n}\n\n.dialog-content p {\n  color: #1c1c1c;\n  font-size: 14px;\n  font-weight: 400px;\n}\n\n.dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.go-to-payments-btn {\n  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);\n  border-radius: 24px;\n  color: white !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n}\n\n::ng-deep .mat-dialog-container {\n  border-radius: 24px !important;\n  padding: 0 !important;\n}\n\n:host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
